/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default class DetailBetIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" css={Color}><g transform="translate(58 -5)"><rect width="46" height="46" transform="translate(-58 5)" fill="#fff" opacity="0" /><g transform="translate(-560.995 -170.06)"><path d="M539.136,175.061H512.819a6.916,6.916,0,0,0-6.841,6.953v32.094a6.916,6.916,0,0,0,6.842,6.952h26.317a6.917,6.917,0,0,0,6.841-6.953V182.014A6.915,6.915,0,0,0,539.136,175.061Zm2.632,39.046a2.657,2.657,0,0,1-2.632,2.674H512.82a2.656,2.656,0,0,1-2.632-2.674V182.014a2.656,2.656,0,0,1,2.632-2.674h26.316a2.657,2.657,0,0,1,2.632,2.674Z" transform="translate(0 0)" fill="#af0" /><path d="M516.938,200.5h0a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,516.938,200.5Z" transform="translate(0.332 1.775)" fill="#af0" /><path d="M537.475,199.816H524.114a1.6,1.6,0,1,0,0,3.209h13.361a1.6,1.6,0,0,0,0-3.209Z" transform="translate(0.675 1.727)" fill="#af0" /><path d="M531.973,205.755h-7.86a1.6,1.6,0,1,0,0,3.209h7.86a1.6,1.6,0,0,0,0-3.209Z" transform="translate(0.764 2.141)" fill="#af0" /><path d="M516.938,184.5h0a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,516.938,184.5Z" transform="translate(0.332 0.659)" fill="#af0" /><path d="M537.475,183.816H524.114a1.6,1.6,0,1,0,0,3.209h13.361a1.6,1.6,0,0,0,0-3.209Z" transform="translate(0.675 0.611)" fill="#af0" /><path d="M524.114,192.964h7.86a1.6,1.6,0,0,0,0-3.209h-7.86a1.6,1.6,0,1,0,0,3.209Z" transform="translate(0.764 1.025)" fill="#af0" /></g></g></svg>
      </Fragment>
    )
  }
}
